const LOG_LEVEL = {
  DEBUG: 0,
  INFO: 1,
  WARN: 2,
  ERROR: 3,
  NONE:10
};

function ILogger (
  debugHandler,
  infoHandler,
  warnHandler,
  errorHandler) {
  if (typeof(debugHandler) !== typeof(()=>{})) debugHandler = () => {};
  if (typeof(infoHandler) !== typeof(()=>{})) infoHandler = () => {};
  if (typeof(warnHandler) !== typeof(()=>{})) warnHandler = () => {};
  if (typeof(errorHandler) !== typeof(()=>{})) errorHandler = () => {};

  function Logger (level) {
    this._level = level; 
  }

  Logger.prototype.debug = function (...args) {
    if(LOG_LEVEL.DEBUG >= this._level) debugHandler(...args);
  };
  Logger.prototype.info = function (...args) {
    if(LOG_LEVEL.INFO >= this._level) infoHandler(...args);
  };
  Logger.prototype.warn = function (...args) {
    if(LOG_LEVEL.WARN >= this._level) warnHandler(...args);
  };
  Logger.prototype.error = function (...args) {
    if(LOG_LEVEL.ERROR >= this._level) errorHandler(...args);
  };

  return Logger;
}

function fmt(msgTyp) {
  let dtString = new Date().toISOString().replace(/T/, ' ').replace(/\..+/, '');
  if (msgTyp.length < 6) msgTyp.padEnd(6, ' ');
  return `${dtString} - ${msgTyp.toUpperCase()}`;
}

const Logger = ILogger(
  (...args) => { console.debug(fmt('debug'), ...args); },
  (...args) => { console.info(fmt('info'), ...args); },
  (...args) => { console.warn(fmt('warn'), ...args); },
  (...args) => { console.error(fmt('error'),...args); }
);

export {
  ILogger,
  Logger,
  LOG_LEVEL
};